import { css, Global } from "@emotion/react";
import styled from "@emotion/styled";
import theme from "@theme/";

const globalStyles = css`
  .ant-select-selector {
    border-radius: 3px !important;
  }
  .ant-select-selection-placeholder {
    color: black !important;
  }
  .ant-select-arrow {
    color: black !important;
  }
  .ant-select-dropdown {
    z-index: 9999 !important;
    padding: 0 !important;
  }
`;

const ChildContainer = styled.div`
  max-height: 200px;
  overflow: auto;
  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-track {
    background: ${theme.colors.bordertask};
  }
  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.themeColor};
    border-radius: 10px;
  }
`;

const SC = {
  Globalstyles: <Global styles={globalStyles} />,
  ChildContainer,
};

export default SC;
